import { TextInput } from "@planningcenter/doxy-web"

type GraduationYearType = {
  graduationYear: {
    attributes: {
      graduation_year: number | null
    }
  }
  updateAttribute: (record: any, attribute: string, value: string) => void
}

export function GraduationYear({
  graduationYear,
  updateAttribute,
}: GraduationYearType) {
  const {
    attributes: { graduation_year },
  } = graduationYear
  return (
    <>
      <div className="label">Graduation Year</div>
      <TextInput
        id="graduation_year"
        onChange={(e) =>
          updateAttribute(graduationYear, "graduation_year", e.target.value)
        }
        value={graduation_year ? graduation_year.toString() : ""}
      />
    </>
  )
}
